import { render, staticRenderFns } from "./ModalMobileMessage.vue?vue&type=template&id=63595c82&scoped=true&"
import script from "./ModalMobileMessage.vue?vue&type=script&lang=ts&"
export * from "./ModalMobileMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMobileMessage.vue?vue&type=style&index=0&id=63595c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63595c82",
  null
  
)

export default component.exports